module.exports = __webpack_public_path__ + "img/well2.f52fd41c.png";